export default "__VITE_ASSET__BUDZHF3S__"